export default __webpack_public_path__ + "static/media/42 (2).01d201e6.jpg";